// extracted by mini-css-extract-plugin
export default {"root":"I4wD7cBtVLgqRD0qyMmN"};